﻿﻿export interface ITicketTagName {
    id: number;
    name: string;
}
